import {
  COCO_BULK_PAYMENT_UPLOAD,
  COCO_PAYMENT_HISTORY_GET,
} from "../types";

/**
 * Uploads parsed payment rows.
 * data: { slug: "rent" | "sd", rows: [...] }
 */
export const cocoBulkPaymentUploadAction = (data, onSuccess, onError) => {
  return {
    type: COCO_BULK_PAYMENT_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

/**
 * Fetches paginated payment history.
 * data: { slug, page, limit, search, search_column, payment_status,
 *         upload_from, upload_to, credited_from, credited_to,
 *         sortBy, sortOrder }
 */
export const cocoPaymentHistoryAction = (data, onSuccess, onError) => {
  return {
    type: COCO_PAYMENT_HISTORY_GET,
    data,
    onSuccess,
    onError,
  };
};
